const SERVER_URL =
  "https://aes-website-backend-nodejs-895924407291.asia-south1.run.app/admin/";
const IMAGE_URL = "https://storage.googleapis.com/kidsstreet-test/";
const SET_FORMAT = (amount) => {
  var formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  });

  return formatter.format(amount);
};
module.exports = {
  SERVER_URL,
  IMAGE_URL,
  SET_FORMAT,
};
